import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// ============== AFFILIATE LINKS ==============

export const getAllAffiliateLinks = async () => {
  try {
    const response = await axios.get(`${BACKEND_URL}/api/affiliate/links`);
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV === 'development') console.error('Error fetching affiliate links:', error);
    throw error;
  }
};

export const getAffiliateLinkById = async (id) => {
  try {
    const response = await axios.get(`${BACKEND_URL}/api/affiliate/links/${id}`);
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV === 'development') console.error('Error fetching affiliate link:', error);
    throw error;
  }
};

export const createAffiliateLink = async (linkData) => {
  try {
    const response = await axios.post(`${BACKEND_URL}/api/affiliate/links`, linkData);
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV === 'development') console.error('Error creating affiliate link:', error);
    throw error;
  }
};

export const updateAffiliateLink = async (id, updateData) => {
  try {
    const response = await axios.put(`${BACKEND_URL}/api/affiliate/links/${id}`, updateData);
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV === 'development') console.error('Error updating affiliate link:', error);
    throw error;
  }
};

export const deleteAffiliateLink = async (id) => {
  try {
    const response = await axios.delete(`${BACKEND_URL}/api/affiliate/links/${id}`);
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV === 'development') console.error('Error deleting affiliate link:', error);
    throw error;
  }
};

// ============== LOUNGES ==============

export const getAllLounges = async () => {
  try {
    const response = await axios.get(`${BACKEND_URL}/api/affiliate/lounges`);
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV === 'development') console.error('Error fetching lounges:', error);
    throw error;
  }
};

export const getLoungeById = async (id) => {
  try {
    const response = await axios.get(`${BACKEND_URL}/api/affiliate/lounges/${id}`);
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV === 'development') console.error('Error fetching lounge:', error);
    throw error;
  }
};

export const createLounge = async (loungeData) => {
  try {
    const response = await axios.post(`${BACKEND_URL}/api/affiliate/lounges`, loungeData);
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV === 'development') console.error('Error creating lounge:', error);
    throw error;
  }
};

export const updateLounge = async (id, updateData) => {
  try {
    const response = await axios.put(`${BACKEND_URL}/api/affiliate/lounges/${id}`, updateData);
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV === 'development') console.error('Error updating lounge:', error);
    throw error;
  }
};

export const deleteLounge = async (id) => {
  try {
    const response = await axios.delete(`${BACKEND_URL}/api/affiliate/lounges/${id}`);
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV === 'development') console.error('Error deleting lounge:', error);
    throw error;
  }
};
